import { makeStyles } from '@material-ui/core';
import Modal from '@material-ui/core/Modal';
import ButtonClose from 'components/ButtonClose/ButtonClose';
import React, { FunctionComponent } from 'react';
import { WithTranslation, withTranslation } from 'react-i18next';

import { colors } from '../../theme/theme';

const useStyles = makeStyles((theme) => ({
	modalBody: {
		marginRight: '30px',
		height: '90%',
		minWidth: '70%',
		position: 'absolute',
		width: '90%',
		backgroundColor: theme.palette.background.paper,
		boxShadow: theme.shadows[5],
		outline: 'none',
		justifyItems: 'center',
		textAlign: 'center',
		paddingTop: '7px',
		paddingRight: '7px',
		paddingLeft: '7px',
		paddingBottom: '12px',
		color: colors.grayA80,
		fontSize: '16px',
		fontWeight: 500,
		letterSpacing: '0.25px',
		lineHeight: '19px',
		top: '50%',
		left: '50%',
		transform: 'translate(-50%, -50%)',
	},
	buttonGroup: {
		display: 'flex',
		marginTop: '2px',
		justifyContent: 'flex-end',
	},
	button: {
		margin: '2px',
		height: 30,
		width: 30,
	},
}));

interface ModalProps extends WithTranslation {
	showModal: boolean;
	handleCloseFn?(): void;
}

const DocumentModal: FunctionComponent<ModalProps> = (props) => {
	const classes = useStyles();

	const handleCancel = () => {
		if (props.handleCloseFn) {
			props.handleCloseFn();
		}
	};

	return (
		<Modal open={props.showModal} onClose={handleCancel}>
			<div className={classes.modalBody}>
				<div className={classes.buttonGroup}>
					<ButtonClose onClick={handleCancel} />
				</div>
				{props.children}
			</div>
		</Modal>
	);
};

export const DOCUMENT_MODAL_HEADER_HEIGHT = '62px';

export default withTranslation()(DocumentModal);
